import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { cleanHTML } from "../../utils/cleanHtml";
import decoJaune from "../../assets/img/decoJaune.png";
import { useMemo } from "react";

export const GridColumns = ({ section }) => (
  <section className="py-20 bg-gradient-to-b from-white to-gray-100 px-6 md:px-12">
    <div className="max-w-6xl mx-auto text-center mb-14">
      <h2 className="text-3xl md:text-4xl font-bold text-gray-800">
        {section.title}
      </h2>
      {section.subtitle && (
        <p className="mt-3 text-gray-600 text-lg">{section.subtitle}</p>
      )}
    </div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
      {section.subsections.map((item, index) => (
        <div
          key={index}
          className="bg-white rounded-2xl shadow-lg p-8 text-center hover:-translate-y-1 transition-all duration-300"
        >
          {item.image && (
            <div className="w-20 h-20 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center overflow-hidden">
              <img
                src={`${process.env.REACT_APP_API_BASE_URL_STORAGE}/${item.image}`}
                alt={item.title}
                className="h-10 w-10"
              />
            </div>
          )}
          <h3 className="text-xl font-semibold text-gray-800">{item.title}</h3>
          <div
            className="text-gray-600 mt-3 text-justify"
            dangerouslySetInnerHTML={{ __html: item.content }}
          />
        </div>
      ))}
    </div>
  </section>
);

export const GridIcons = ({ section }) => (
  <section className="py-16 px-6 md:px-12 bg-white text-gray-800">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      {/* ➕ Gauche : Infos de la section */}
      <div>
        {section.title && (
          <p className="text-lg text-gray-600 mb-2">{section.title}</p>
        )}
        {section.subtitle && (
          <h1 className="font-bold mb-4">{section.subtitle}</h1>
        )}
        {section.content && (
          <div
            className="text-gray-700 mb-6 leading-relaxed text-justify"
            dangerouslySetInnerHTML={{ __html: section.content }}
          />
        )}
        {/* {section.image && (
          <img
            src={`${process.env.REACT_APP_API_BASE_URL_STORAGE}/${section.image}`}
            alt={section.title}
            className="mb-6 w-full h-80 object-contain rounded shadow"
          />
        )} */}
        {section.button_text && section.button_link && (
          <a
            href={section.button_link}
            className="inline-block bg-orange-600 hover:bg-orange-700 text-white px-6 py-3 rounded font-semibold transition"
          >
            {section.button_text}
          </a>
        )}
      </div>

      {/* ➕ Droite : Cartes des sous-sections */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {section.subsections.map((item, index) => (
          <div
            key={index}
            className="border rounded-lg overflow-hidden shadow pt-5 flex flex-col"
          >
            {/* Icône ou image */}
            <span className="px-4 rounded-full overflow-hidden w-fit text-green-600 text-xl">
              {item.icon ? (
                <i className={`${item.icon}`} />
              ) : (
                <i className="fas fa-circle-question" />
              )}
            </span>

            <div className="p-4">
              <h3 className="text-xl font-semibold">{item.title}</h3>
              {item.subtitle && (
                <p className="text-sm text-gray-500">{item.subtitle}</p>
              )}
              {item.content && (
                <div
                  className="text-gray-600 mt-2 text-sm"
                  dangerouslySetInnerHTML={{ __html: item.content }}
                />
              )}

              {item.button_text && item.button_link && (
                <a
                  href={item.button_link}
                  className="inline-block mt-4 text-orange-600 hover:underline text-sm"
                >
                  {item.button_text}
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const GridCards = ({ section }) => (
  <section
    id="nos-services"
    className="py-20 bg-slate-100 px-6 md:px-12 w-full"
  >
    <div className="max-w-7xl mx-auto">
      <div className="mb-10 text-center">
        <p className="mt-3 text-yellowCustom text-sm">{section.title}</p>
        {section.subtitle && (
          <h1 className="text-3xl md:text-4xl font-semibold text-primary">
            {section.subtitle}
          </h1>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mx-auto">
        {section.subsections.map((item, index) => (
          <div
            key={index}
            className="border rounded-xl hover:shadow-lg overflow-hidden flex flex-col transition-all duration-300 bg-white"
          >
            <div className="p-4 ">
              {item.image ? (
                <img
                  src={`${process.env.REACT_APP_API_BASE_URL_STORAGE}/${item.image}`}
                  alt={item.title}
                  className="w-full h-56 rounded-xl object-contain"
                />
              ) : (
                <div className="w-full h-56 rounded-xl bg-slate-500 flex items-center justify-center text-gray-400">
                  <i className="fa fa-image text-4xl"></i>
                </div>
              )}
            </div>

            <div className="px-6 pb-6 flex flex-col justify-between flex-1">
              <div>
                {/* <p className="text-xs text-gray-300">{item.subtitle}</p> */}
                <h3 className="text-xl font-bold text-primary">{item.title}</h3>
                <div
                  className="my-4 text-xs text-justify"
                  dangerouslySetInnerHTML={{ __html: cleanHTML(item.content) }}
                />
                {item.button_text && item.button_link && (
                  <a
                    href={item.button_link}
                    className="rounded-full px-4 bg-yellowCustom text-white px-3 py-2 font-medium hover:opacity-70 transition"
                  >
                    {item.button_text}
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const GridImages = ({ section }) => (
  <section className="py-20 bg-slate-100 px-6 md:px-12 w-full">
    <div className="max-w-7xl mx-auto">
      {/* Header section */}
      <div className="max-w-2xl mx-auto mb-10 text-center">
        <h1 className="text-3xl md:text-4xl font-semibold text-primary">
          {section.title}
        </h1>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mx-auto">
        {section.subsections.map((item, index) => (
          <div
            key={index}
            className="relative rounded-xl overflow-hidden group h-72 flex items-end justify-center"
            style={{
              backgroundImage: item.image
                ? `url(${process.env.REACT_APP_API_BASE_URL_STORAGE}/${item.image})`
                : "none",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            {/* Fallback si pas d'image */}
            {!item.image && (
              <div className="absolute inset-0 bg-slate-500 flex items-center justify-center text-gray-300 text-4xl">
                <i className="fa fa-image"></i>
              </div>
            )}

            {/* Backdrop */}
            <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-60 transition"></div>

            {/* Texte en bas */}
            <div className="relative z-10 p-6 text-center text-white w-full">
              {item.subtitle && (
                <p className="text-sm mb-1 opacity-90">{item.subtitle}</p>
              )}
              <h3 className="text-xl font-bold mb-3">{item.title}</h3>
              {item.button_text && item.button_link && (
                <a
                  href={item.button_link}
                  className="inline-block rounded-full bg-yellowCustom text-white px-4 py-2 font-medium hover:opacity-80 transition"
                >
                  {item.button_text}
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const GridCardsWithoutImage = ({ section }) => {
  const [rubriques, setRubriques] = useState([]);
  const LINK = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetch(`${LINK}/api/rubriques-public`)
      .then((res) => res.json())
      .then((data) => setRubriques(data))
      .catch((err) => console.error("Erreur chargement rubriques:", err));
  }, [LINK]);

  return (
    <section id="services" className="bg-background px-6 md:px-12 ">
      <div className="max-w-7xl mx-auto w-full">
        {/* Titre et sous-titre */}
        <div className="mb-10">
          <h1 className="text-3xl md:text-4xl font-bold text-primary">
            {section.title}
          </h1>
          {section.subtitle && (
            <p className="mt-3 text-gray-600 text-sm">{section.subtitle}</p>
          )}
        </div>

        {/* Grid de cartes */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mx-auto">
          {section.subsections.map((item, index) => (
            <div
              key={index}
              className="rounded-3xl bg-white border border-slate-200 p-4 hover:shadow-lg overflow-hidden flex flex-col transition-all duration-300"
            >
              <div className="p-6 flex flex-col justify-between flex-1">
                <div>
                  <h3 className="text-xl font-semibold text-primary">
                    {item.title}
                  </h3>
                  <div
                    className="text-gray-600 mt-2 text-sm text-justify"
                    dangerouslySetInnerHTML={{
                      __html: cleanHTML(item.content),
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Tableau dynamique */}
        {rubriques.length > 0 && (
          <div className="mt-10 overflow-x-auto rounded-2xl border border-slate-200 bg-white">
            <table className="w-full text-sm">
              <thead className="bg-primary text-white">
                <tr>
                  <th className="text-left pl-10">Rubrique</th>
                  {rubriques.map((r) => (
                    <th key={r.id} className="text-left p-3">
                      {r.titre}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 text-primary">
                <tr>
                  <td className="pl-10">Plage de support</td>
                  {rubriques.map((r) => (
                    <td key={r.id} className="p-3">
                      {r.plage_support}
                    </td>
                  ))}
                </tr>
                <tr>
                  <td className="pl-10">TTI / TTR cibles</td>
                  {rubriques.map((r) => (
                    <td key={r.id} className="p-3">
                      {r.tti_ttr}
                    </td>
                  ))}
                </tr>
                <tr>
                  <td className="pl-10">Préventif</td>
                  {rubriques.map((r) => (
                    <td key={r.id} className="p-3">
                      {r.preventif}
                    </td>
                  ))}
                </tr>
                <tr>
                  <td className="pl-10">Pièces & consommables</td>
                  {rubriques.map((r) => (
                    <td key={r.id} className="p-3">
                      {r.pieces_conso}
                    </td>
                  ))}
                </tr>
                <tr>
                  <td className="pl-10">Reporting</td>
                  {rubriques.map((r) => (
                    <td key={r.id} className="p-3">
                      {r.reporting}
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
};

export function GridWithoutTitle({ section }) {
  return (
    <section id="produits" className="py-20 px-6 md:px-12">
      {/* Titre + Sous-titre */}
      <div className="mb-10">
        <h1 className="text-3xl md:text-4xl font-semibold text-primary">
          {section.title}
        </h1>
        {section.subtitle && (
          <p className="mt-3 text-gray-600 text-lg">{section.subtitle}</p>
        )}
      </div>
      <div className="flex flex-wrap justify-center gap-6">
        {(section.subsections || []).map((item, i) => (
          <Link
            key={i}
            to={item.button_link || "/"}
            className="relative rounded-xl overflow-hidden shadow-lg w-full md:w-[48%] lg:w-[22%] h-[370px] m-h-[360px] aspect-[3/4] flex items-center justify-center text-center bg-primary text-white hover:-translate-y-1 transition-all duration-300"
          >
            <div className="flex flex-col items-center justify-center p-6">
              {item.image && (
                <img
                  src={`${process.env.REACT_APP_API_BASE_URL_STORAGE}/${item.image}`}
                  alt={item.title}
                  className="w-48 h-48 mb-4 object-contain"
                />
              )}
              <h3 className="text-lg font-bold mb-1 uppercase">GAMME</h3>
              <h1 className="text-3xl font-bold mb-1 uppercase">
                {item.title}
              </h1>
              {item.subtitle && (
                <p className="text-sm opacity-80">{item.subtitle}</p>
              )}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}

export const GridRows = ({ section }) => {
  if (!section?.subsections?.length) return null;

  return (
    <section
      id="downloads"
      className="min-h-screen py-20 bg-white relative overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl md:text-4xl font-bold text-primary">
          {section.title}
        </h1>{" "}
        <ul className="mt-6 grid md:grid-cols-2 gap-4 text-sm">
          {section.subsections.map((item, index) => (
            <li
              key={index}
              className="rounded-2xl border border-2 border-slate-600 p-4 flex items-center justify-between"
            >
              <span>{item.title}</span>
              {item.button_text && item.button_link && (
                <a
                  href={item.button_link}
                  target="_blank"
                  rel="noreferrer"
                  className="underline-force underline-offset-4"
                  onClick={() =>
                    window.gtag &&
                    window.gtag("event", "download_fiche", {
                      label: item.title,
                    })
                  }
                >
                  {item.button_text}
                </a>
              )}
            </li>
          ))}
        </ul>
      </div>

      <div className="absolute top-0 right-0 h-full w-auto pointer-events-none flex flex-col">
        {Array.from({ length: 4 }).map((_, i) => (
          <img
            key={i}
            src={decoJaune}
            alt="decor"
            className="opacity-50 w-auto h-[200px] object-contain"
            style={{
              filter: "hue-rotate(180deg) saturate(200%) brightness(0.8)", // recoloration bleu
            }}
          />
        ))}
      </div>
    </section>
  );
};

export const GridThreeIcon = ({ section }) => {
  return (
    <section className="py-20 bg-white px-6 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {section.subsections.map((item, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center p-6 border rounded-xl shadow-sm hover:shadow-lg transition"
          >
            {item.icon && (
              <div className="text-4xl text-orange-600 mb-4">
                <i className={item.icon}></i>
              </div>
            )}
            <h3 className="text-xl font-semibold text-gray-800">
              {item.title}
            </h3>
            {item.subtitle && (
              <p className="text-sm text-gray-500 mt-1">{item.subtitle}</p>
            )}
            {item.content && (
              <div
                className="mt-2 text-gray-600 text-sm"
                dangerouslySetInnerHTML={{ __html: item.content }}
              />
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export function CategoryGrid({ section }) {
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(true);
  const LINK = process.env.REACT_APP_API_URL;

  useEffect(() => {
    setLoading(true);
    fetch(`${LINK}/api/menus-public`)
      .then((res) => res.json())
      .then((data) => {
        setMenus(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Erreur chargement menus:", err);
        setLoading(false);
      });
  }, [LINK]);

  // On regroupe les menus par type (clé = nom du type)
  const menusParType = useMemo(() => {
    const map = {};

    menus.forEach((menu) => {
      const type = menu.type;
      if (!type) return;

      if (!map[type]) {
        map[type] = [];
      }

      map[type].push(menu);
    });

    return map;
  }, [menus]);

  // On limite à 4 types max pour l'affichage
  const typesAffiches = useMemo(() => {
    return Object.keys(menusParType)
      .slice(0, 4)
      .map((type) => ({
        type: type,
        menus: menusParType[type],
      }));
  }, [menusParType]);

  return (
    <section id="menus" className="py-20 px-6 md:px-24">
      <div className="max-w-6xl mx-auto mb-14">
        <h2 className="text-3xl md:text-4xl font-semibold text-primary">
          {section.title}
        </h2>
        {section.subtitle && (
          <p className="mt-3 text-gray-600 text-lg">{section.subtitle}</p>
        )}
      </div>

      {loading ? (
        // ✅ SKELETON
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto animate-pulse">
          {Array.from({ length: 6 }).map((_, index) => (
            <div
              key={index}
              className="bg-gray-100 rounded-2xl p-8 shadow-md flex flex-col justify-between min-h-[200px]"
            >
              {/* Skeleton Header */}
              <div className="flex items-center justify-center mb-4 gap-3">
                <div className="w-10 h-10 bg-gray-300 rounded-full"></div>
                <div className="h-4 w-24 bg-gray-300 rounded"></div>
                <div className="w-10 h-10 bg-gray-300 rounded-full"></div>
              </div>

              {/* Skeleton Produits */}
              <ul className="mt-4 space-y-2">
                {Array.from({ length: 5 }).map((_, i) => (
                  <li key={i} className="h-3 w-3/4 bg-gray-300 rounded"></li>
                ))}
              </ul>

              {/* Skeleton bouton */}
              <div className="mt-6 w-1/2 mx-auto h-4 bg-gray-300 rounded"></div>
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {typesAffiches.map((cat, index) => (
            <div
              key={index}
              className="bg-gray-200 rounded-2xl shadow-lg p-8 hover:-translate-y-1 transition-all duration-300 flex flex-col justify-between min-h-[100px]"
            >
              {/* HEADER */}
              <div className="">
                <h3 className="text-xl font-semibold text-gray-800">
                  {cat.type}
                </h3>
              </div>

              <ul className="text-left mt-2 text-gray-700">
                {cat.menus.slice(0, 5).map((menu) => (
                  <>
                    <li
                      key={menu.id}
                      className="mb-1 capitalize flex justify-between text-gray-800"
                    >
                      <p className="break-words max-w-[70%]">
                        •&nbsp;{menu.titre}
                      </p>
                      {menu.prix && (
                        <p className="shrink-0">{menu.prix} FCFA</p>
                      )}
                    </li>

                    <p className="text-sm text-gray-500 mb-3">
                      {menu.description}
                    </p>
                  </>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}

export function GalerieGrid({ section }) {
  const [galeries, setGaleries] = useState([]);
  const [loading, setLoading] = useState(true);
  const LINK = process.env.REACT_APP_API_URL;
  const STORAGE = process.env.REACT_APP_API_BASE_URL_STORAGE;
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    setLoading(true);
    fetch(`${LINK}/api/galeries-public`)
      .then((res) => res.json())
      .then((data) => {
        setGaleries(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Erreur chargement galeries:", err);
        setLoading(false);
      });
  }, [LINK]);

  // On regroupe les galeries par type (clé = nom du type)
  const galeriesParType = useMemo(() => {
    const map = {};

    galeries.forEach((img) => {
      const type = img.type;
      if (!type) return;

      if (!map[type]) {
        map[type] = [];
      }

      map[type].push(img);
    });

    return map;
  }, [galeries]);

  // On limite à 4 types max pour l'affichage
  const typesAffiches = useMemo(() => {
    return Object.keys(galeriesParType)
      .sort((a, b) => b.localeCompare(a)) // Tri alphabétique des types
      .slice(0, 4)
      .map((type) => ({
        type: type,
        galeries: galeriesParType[type],
      }));
  }, [galeriesParType]);

  return (
    <div id="galeries" className="py-20">
      <div className="max-w-6xl mx-auto mb-14 px-6 xl:px-0">
        <h2 className="text-3xl md:text-4xl font-semibold text-primary">
          {section.title}
        </h2>
        {section.subtitle && (
          <p className="mt-3 text-gray-600 text-lg">{section.subtitle}</p>
        )}
      </div>

      {loading ? (
        // ✅ SKELETON
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 px-6 animate-pulse">
          {Array.from({ length: 2 }).map((_, index) => (
            <div
              key={index}
              className="rounded-2xl p-8 shadow-md min-h-[200px] bg-gray-100"
            >
              {/* Skeleton titre */}
              <div className="h-6 w-32 bg-gray-300 rounded mb-6"></div>

              {/* Skeleton grid 3x3 */}
              <div className="grid grid-cols-3 gap-2">
                {Array.from({ length: 9 }).map((_, i) => (
                  <div
                    key={i}
                    className="w-full aspect-square bg-gray-300 rounded"
                  ></div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 w-full">
          {typesAffiches.slice(0, 2).map((cat, index) => (
            <div
              key={index}
              className={`shadow-lg p-12 min-h-[200px] ${
                cat.type === "Restaurant" ? "bg-primary" : "bg-om"
              }`}
            >
              {/* HEADER */}
              <h3 className="text-xl font-semibold text-white mb-4">
                {cat.type}
              </h3>

              {/* GRID 3x3 */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2">
                {cat.galeries.slice(0, 12).map((item) => (
                  <div
                    key={item.id}
                    className="w-full aspect-square cursor-pointer"
                    onClick={() => setSelectedImage(item.image)}
                  >
                    {item.image ? (
                      <img
                        src={`${STORAGE}/${item.image}`}
                        alt={item.titre}
                        className="w-full h-full object-cover rounded hover:opacity-80 transition"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center bg-gray-200 rounded">
                        <i className="fas fa-image text-gray-400 text-2xl"></i>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
      {/* Popup */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-[999]"
          onClick={() => setSelectedImage(null)}
        >
          <div
            className="bg-white rounded-lg p-4 relative max-w-lg w-full shadow-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-4 right-4 text-white hover:text-gray-500 bg-red-500 shadow-lg h-10 w-10 rounded-full text-lg transition duration-300"
              onClick={() => setSelectedImage(null)}
            >
              ✖
            </button>
            <img
              src={`${STORAGE}/${selectedImage}`}
              alt="Popup"
              className="max-h-[80vh] w-auto h-auto rounded object-contain"
            />
          </div>
        </div>
      )}
    </div>
  );
}
